import ModuleFormPage from '../modules/module-form.page'

export default function WeiterbildungFormPage() {
  return <ModuleFormPage moduleType='weiterbildung' />
}
